import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { CacheService } from '../services/cache.service';
import { ConstantsService } from '../services/constants.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { GetPaymentService } from '../services/get-payment.service';
import { SpinnerService } from '../services/spinner.service';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { environment } from 'src/environments/environment';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
// import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})

export class PaymentComponent implements OnInit, OnDestroy {
  @ViewChild(StripeCardNumberComponent) card: any = StripeCardNumberComponent;
  public cardOptions: StripeCardElementOptions = this.constants.SRIPE_CARD_STYLE;
  public elementsOptions: StripeElementsOptions = { locale: 'en' };
  public stripeTest: any = UntypedFormGroup;
  public isLoading: boolean = false;
  public paymentSuccess = false;
  public foundError = false;
  public checked = false;
  public errorMessage = ''
  public buttonValue: string = this.constants.PAY_5_TXT;
  public amount: number = 5;
  public user = {
    given_name: '',
    userEmail: '',
    userName: ''
  }
  login: boolean = false;
  primeamount: number;
  constructor(
    public constants: ConstantsService,
    private authenticate: CacheService,
    private fb: UntypedFormBuilder,
    private stripeService: StripeService,
    private paymentService: GetPaymentService,
    private userService: UserService,
    private spinner: SpinnerService,
    private router: Router,
    private mixpanel: SharedMixpanelService,
    // private helperService:HelperService
  ) { }

  ngOnInit() {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authenticate.fromPricingPage = 'false';
    this.authcall();
    this.stripeTest = this.fb.group({ name: ['', [Validators.required]] });
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }

  public async authcall() {
    // Get current user data from db for get the email and name
    this.authenticate.getAuthUser()
      .then(async (data) => {
        this.login = data.login;
        this.user.userEmail = data.email;
        this.user.given_name = data.given_name;
        this.user.userName = data.userName;
        this.spinner.hide();
        await this.userService.getUser(false)
          .then(data => {
            if (data.prime) {
              if (data.prime.amount === 50) {
                this.primeamount = 50;
              } else if (data.prime.amount === 5) {
                this.primeamount = 50;
              } else if (data.prime.amount === 20) {
                this.primeamount = 20;
              } else {
                this.primeamount = 50;
              }
            } else {
              this.primeamount = 50;
            }
          });
      })
      .catch(() => {
        this.spinner.hide()
      });
  }
  createToken(): void {
    let checkCardError = (this.card.stripeElementRef.nativeElement).getAttribute("class")
    let { given_name, userEmail, userName } = this.user;
    if (checkCardError.includes(this.constants.EMPTY_TXT)) {
      this.foundError = true;
      this.errorMessage = this.constants.ENTER_CARD_TXT
    }
    else {
      let name = this.stripeTest.get('name').value;
      name === '' ? name = given_name : name = name;
      this.isLoading = true;
      this.foundError = false;
      // Genarate stripe token for payment, 
      // this will be used to create a customer,
      // and then charge the customer
      this.stripeService.createToken(this.card.element, { name })
        .subscribe((result) => {
          if (result.token) {
            let data = {
              userName,
              prime: {
                userEmail,
                userName: name,
                amount: this.amount,
                cardToken: result.token.id,
              },
            }
            this.makePayment(data);
          }
          if (result.error) {
            this.isLoading = false;
            this.foundError = true;
            this.errorMessage = result.error.message
          }
        });
    }
  }

  makePayment(data): void {
    this.mixpanel.actions.track("Prime payment", {
      "Email": data.userEmail,
      "Name": data.userName,
      "Amount": data.prime.amount
    });
    // Update user profile with payment table,
    // Add Prime Expiry date to user table
    this.paymentService.primePayment(data)
      .then((data) => {
        // Retive latest data from user table
        this.userService.getUser(true)
        this.paymentSuccess = true
        localStorage['afterSuccessPrime'] = true;
        this.isLoading = false;
        this.userService.userData = undefined;
        this.userService.isFirstCall = true;
      })
      .catch(error => {
        this.mixpanel.actions.track("Error in payment", {
          "Email": data.userEmail,
          "Name": data.userName,
          "Amount": data.prime.amount,
          "error": error
        });
        this.foundError = true;
        this.errorMessage = error.error.msg;
        this.isLoading = false;
      });
  }

  OnClickClose = () => {
    if(this.paymentSuccess){
      this.router.navigate(['/']);
    }
    this.router.navigate(['/pricing'])
  }

  paymentToggle(): void {
    this.checked = !this.checked;
    this.checked && this.primeamount === 50 ? `${this.buttonValue = this.constants.PAY_50_TXT}, ${this.amount = 50}` : this.checked && this.primeamount === 20 ? `${this.buttonValue = this.constants.PAY_20_TXT}, ${this.amount = 20}` : `${this.buttonValue = this.constants.PAY_5_TXT}, ${this.amount = 5}`;
  }
}


